import {inject, Injectable} from '@angular/core';
import {PreorderRestService} from '../../../services/api/preorder.rest-service';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Observable} from 'rxjs';
import {Action} from '@ngrx/store';
import * as fromPreorderProductActions from '../../actions/preorder/product.actions';
import {catchError, map, switchMap} from 'rxjs/operators';
import {of} from 'rxjs/internal/observable/of';
import {
    LoadOrderedProductsComplete,
    LoadOrderedProductsFailed,
    ProductActionTypes
} from '../../actions/preorder/product.actions';


@Injectable()
export class PreorderProductEffects {
    private actions$ = inject(Actions);
    private preorderRestService = inject(PreorderRestService);


    loadProducts$ = createEffect(() =>
        this.actions$.pipe(
            ofType(
                ProductActionTypes.INIT_LOAD_ORDERED_PRODUCTS
            ),
            switchMap(({ payload: preOrderId }) =>
                this.preorderRestService.loadProductsByPreorderId(preOrderId).pipe(
                    map(res =>
                        new LoadOrderedProductsComplete(res.returnObject)
                    ),
                    catchError(error =>
                        of(new LoadOrderedProductsFailed(error))
                    )
                )
            )
        )
    );
}
